var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h5',{class:['mb-0', _vm.getClass]},[_vm._v(_vm._s(_vm._f("moneyFormat")(_vm.price,_vm.currency)))])}
var staticRenderFns = []

export { render, staticRenderFns }